module.exports = __webpack_public_path__ + "static/day20-af59b4d98c3bbd0f22a0fc44fd67e3be.png";